import styled from 'styled-components';

export const IntegrationsList = styled.div`
  div.item {
    display: flex;
    align-items: center;
    /* max-width: 800px; */
    height: 66px;
    background: #ffffff;
    box-shadow: 0px 2px 9px rgba(22, 29, 37, 0.1);
    border-radius: 6px;
    padding: 0 30px;
    div.integration-name {
      flex-grow: 1;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #000000;
    }
    & > :not(:last-child) {
      margin-right: 16px;
    }
    :not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

export const StatusText = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #475867;
  margin-bottom: 24px;
`;
